import { useCallback, useState } from "react"
import { useGrantAmnestyV1TohMutation } from "../../core/api/toh-social-api"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"

const TohGrantAmnestyControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState("")
    const [expiresAt, setExpiresAt] = useState(null)

    const [grant, { isLoading }] = useGrantAmnestyV1TohMutation()

    const handleOpenDialog = useCallback(() => {
        setOpen(true)
    }, [setOpen])

    const handleCloseDialog = useCallback(() => {
        setOpen(false)
        setReason("")
        setExpiresAt(null)
    }, [setOpen, setReason, setExpiresAt])

    const handleChangeReason = useCallback((e) => {
        const value = e?.target?.value ?? ""
        if (value.length <= 100) {
            setReason(value)
        }
    }, [setReason])

    const handleConfirm = useCallback(() => {
        if (!expiresAt) return
        grant({
            userId: userId,
            reason: reason.trim(),
            expiresAt: expiresAt.toISOString()
        })
        handleCloseDialog()
    }, [userId, reason, expiresAt, grant, handleCloseDialog])

    const isFuture = expiresAt && expiresAt.isAfter(dayjs())
    const canConfirm = reason.trim() !== "" && isFuture

    return (
        <>
            <Button
                fullWidth
                color="warning"
                size="small"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenDialog}
                variant={"outlined"}

            >
                Grant amnesty
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <DialogTitle>
                    Grant amnesty for '{userId}'
                </DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "16px !important" }}>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={2}
                        margin="dense"
                        label="Reason"
                        value={reason}
                        onChange={handleChangeReason}
                        helperText={`${reason.length}/100`}
                        inputProps={{ maxLength: 100 }}
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Expires at"
                            value={expiresAt}
                            onChange={(newValue) => setExpiresAt(newValue)}
                            format={'DD/MM/YYYY HH:mm'}
                            minDateTime={dayjs()}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: "outlined",
                                    size: "small"
                                }
                            }}
                        />
                    </LocalizationProvider>
                    <Typography variant="caption" color="text.secondary">
                        Amnesty expires at the selected future time.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Button variant="contained" disabled={!canConfirm} onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohGrantAmnestyControl
